
import  { Component } from "react";

class GifSearch extends Component {
  state = {
    inputValue: "",
  };
  hendleChange = (event) => {
    this.setState({ inputValue: event.target.value });


  };
        handleSubmit = () => {
      this.props.onSearch(this.state.inputValue);
    };
  render() {
    return (
     <div className="search">
  <div className="search__box">
    <input
      className="search__input"
      type="text"
      placeholder="Search GIFs..."
      value={this.state.inputValue}
      onChange={this.hendleChange}
    />
    <button className="search__button" onClick={this.handleSubmit}>
      🔍
    </button>
  </div>
</div>
    );
  }
}

export default GifSearch;
